// extracted by mini-css-extract-plugin
export var activeLink = "nav-module--activeLink--cb680";
export var donateButton = "nav-module--donateButton--77728";
export var menuButton = "nav-module--menuButton--6ffd9";
export var menuButtonSVG = "nav-module--menuButtonSVG--68b08";
export var navList = "nav-module--navList--4c65b";
export var navListDesktop = "nav-module--navListDesktop--d95d0";
export var navListMobile = "nav-module--navListMobile--34b62";
export var siteNav = "nav-module--siteNav--336a5";